<template lang="pug">
v-footer.pa-0.d-flex.flex-column
  img.main-footer-banner(src="/img/footer-banner.jpg")
  grid-container.secondary.w-100.justify-center.px-4.py-6(
    cols="100%",
    cols-md="auto 450px",
    gap="40px"
  )
    div
      div
        .text-h4.font-weight-bold
          div FALE
          div CONOSCO
        .text-body-1.font-weight-bold.mt-1 Dúvidas, sugestões, entre em contato agora.
      contact-us-form.mt-3(
        :action="server + '/rest/email/contact-us'",
        alternative
      )
    iframe.rounded-xl(
      :src="informations.map",
      width="100%",
      height="450",
      style="border: 0",
      allowfullscreen="",
      loading="lazy"
    )
  .primary.w-100
    v-container.d-flex.flex-column.flex-sm-row.justify-space-around.align-center.py-6
      v-img(:src="files + informations.img", max-width="260px", contain)
      .my-6
        div(v-if="informations.tel")
          v-btn.text-none(
            :href="getTelLinkFromPhone(informations.tel)",
            target="_blank",
            color="white",
            text
          )
            v-icon(small, left) fas fa-phone
            span.barlow {{ informations.tel }}
        div(v-if="informations.email")
          v-btn.text-none(
            :href="'mailto:' + informations.email",
            target="_blank",
            color="white",
            text
          )
            v-icon(small, left) fas fa-envelope
            span.barlow {{ informations.email }}
        div(v-if="informations.local")
          v-btn.text-none(
            :href="informations.local_link",
            target="_blank",
            text,
            color="white"
          )
            v-icon(small, left) fas fa-map-marked-alt
            span.barlow {{ informations.local }}
      .white--text
        .d-flex.flex-sm-column
          v-btn(color="white", icon, x-large)
            v-icon(large) fab fa-facebook
          v-btn(color="white", icon, x-large)
            v-icon(large) fab fa-instagram
  v-divider.w-100.primary.darken-3
  .px-4.py-4.d-flex.justify-space-around.align-center.w-100.primary.darken-2
    span.white--text.text-center.py-2.text-body-2.font-weight-bold {{ informations.name }} © 2020. Todos os direitos reservados.
    a(href="https://www.mrxweb.com.br/", target="_blank")
      img.logo-mrx(
        src="/img/mrx.svg",
        alt="MRX Web Sites",
        title="MRX Web Sites"
      )
</template>

<script>
import ContactUsForm from "@/components/forms/ContactUs";
import { getTelLinkFromPhone } from "../utils";
export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    ContactUsForm,
  },
};
</script>

<style>
.main-footer-banner {
  max-height: 240px;
  width: 100%;
  background-color: #00b3f5;
  object-fit: contain;
}
.logo-mrx {
  height: 20px;
  filter: brightness(0) invert(1);
}
</style>
